export default {
  appName: 'Ahora Patagonia',
  loading: 'Cargando…',
  error: 'Ocurrió un error',
  retry: 'Reintentar',
  actions: {
    save: 'Guardar',
    cancel: 'Cancelar',
    create: 'Crear',
    edit: 'Editar',
    delete: 'Eliminar',
    back: 'Volver',
    close: 'Cerrar',
    confirm: 'Confirmar',
  },
  nav: {
    home: 'Inicio',
  },
  home: {
    welcome: 'Bienvenido. Personalizá tus secciones en layout/nav.tsx.',
  },
  auth: {
    title: 'Ahora Patagonia',
    subtitle: 'Iniciá sesión para continuar',
    emailLabel: 'Email',
    passwordLabel: 'Contraseña',
    togglePassword: 'Mostrar/ocultar contraseña',
    forgotLink: '¿Olvidaste tu contraseña?',
    submit: 'Iniciar sesión',
    hero: {
      titleStrong: 'Ahora Patagonia',
      titleSoft: 'todo en un solo lugar.',
      subtitle: 'Gestioná tu operación con una plataforma simple y segura.',
    },
    forgot: {
      backToLogin: 'Volver al inicio de sesión',
      request: { title: 'Recuperar contraseña', subtitle: 'Ingresá tu email y te enviamos un código.', submit: 'Enviar código' },
      verify: { title: 'Verificá el código', subtitle: 'Revisá tu email e ingresá el código de 6 dígitos.', codeLabel: 'Código', submit: 'Verificar' },
      reset: { title: 'Nueva contraseña', subtitle: 'Elegí una contraseña nueva (mínimo 8 caracteres).', newPasswordLabel: 'Nueva contraseña', submit: 'Cambiar contraseña' },
      done: { title: '¡Listo!', subtitle: 'Tu contraseña se cambió. Ya podés iniciar sesión.' },
    },
  },
  language: {
    label: 'Idioma',
    es: 'Español',
    en: 'Inglés',
  },
} as const;
